import '../styles/frame.css';
import { Outlet, useLocation, } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { useCart } from './CartContext';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';

import { IoCartOutline } from "react-icons/io5";

export default function Frame() {
  const location = useLocation();
  const { cart, cartCount } = useCart();
  const [account, setAccount] = useState({ label: 'Log In', link: '/login' });

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          const attributes = await fetchUserAttributes(user);
          setAccount({ label: attributes.given_name || "My Account", link: '/account' });
        }
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    }

    checkUser();
  }, []);


  const getBackLink = () => {
    
    /* deciding back link based on current page */
    let paths = location.pathname.split('/');
    paths = paths.filter(path => path !== '');

    // this means they are on a product subpage (personalize, preview, etd)
    if (paths.length > 2) {
      if (paths[2] === 'personalize') {
        return `https://grieversandfriends.com/books/${paths[1]}`;
      } else if (paths[2] === 'preview') {
        return `/books/${paths[1]}/personalize`;
      }
    }

    // if they are in the cart page, back button goes to products list
    if (paths[0] === "cart" || paths[0] === "success" || paths[0] === "account" || paths[0] === "login" || paths[0] === "signup") {
      return "/";
    }

  }
    return (

      /* navbar layout */
      <>
      <nav className="navbar">
      <div className="navbar-container">
      <div className="navbar-left">
        <li className="navbar-item">
        <a href={getBackLink()} className="navbar-link">
          {location.pathname.includes('personalize') ? "Exit" : (location.pathname.includes('cart') || location.pathname.includes('order') ? "" : "Back")}
        </a>
        </li>
      </div>
      <div className="navbar-logo-container">
        <a href="https://grieversandfriends.com/" className="navbar-logo-link">
          <img src={'/topnav-logo.png'} alt="Grievers + Friends" className="navbar-logo" />
        </a>
      </div>
      <div className="navbar-right">
        <ul className="navbar-items">
        <li className="navbar-item">
          <a href={account['link']} className="navbar-link">{account['label']}</a>
        </li>
    
        <li className="navbar-item">
          <a href="/cart" className="cart-link">
            <IoCartOutline className="cart-icon" />
            <span className="cart-count">Cart {cartCount > 0 ? <span>({cartCount})</span> : null}</span>
          </a>
        </li>
        </ul>
      </div>
      </div>
      </nav>


      <Outlet />


      </>
    );
  }